import { atom } from "recoil";

export const permissionCodeObj = atom({
  key: "permissionCodeObj",
  default: {},
});

export const applicationPermissions = atom({
  key: "applicationPermissions",
  default: [] as string[],
}); 